import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { connect } from "react-redux";
import { Link } from "@quintype/components";

import styles from "./styles.m.css";

const StoryLockButton = ({ text, btnDescription, href }) => (
  <div className={styles["btn-container"]}>
    <div className={styles["text-content"]} dangerouslySetInnerHTML={{ __html: text }} />
    <Link className={styles["action-btn"]} href={href} externalLink={href}>
      {btnDescription}
    </Link>
  </div>
);

StoryLockButton.propTypes = {
  text: PropTypes.string,
  btnDescription: PropTypes.string,
  href: PropTypes.string
};

const StoryViewStatusBase = ({ remainingStoriesCount }) => (
  <div className={styles["story-view-status"]}>
    <span> நீங்கள் மேலும்</span>
    <span className={styles["story-view-counter"]}>{remainingStoriesCount}</span>
    <span>கட்டுரைகளை படிக்கலாம்</span>
  </div>
);

StoryViewStatusBase.propTypes = {
  remainingStoriesCount: PropTypes.number
};

function StoryViewStatusMapStateToProps(state) {
  const remainingStoriesCount = get(state, ["storiesCounter", "remainingStoriesCount"]);
  return {
    remainingStoriesCount: remainingStoriesCount
  };
}

const StoryViewStatus = connect(StoryViewStatusMapStateToProps)(StoryViewStatusBase);

const StoryLock = ({ access, className = "", loginLink, subscriptionLink, collectionId }) => {
  if (!access) {
    return null;
  }
  if (collectionId) {
    subscriptionLink = `${subscriptionLink}?sid=${collectionId}`;
    if (!access.granted && (access.grantReason === "METERING" || access.grantReason === "METERING LOCAL")) {
      subscriptionLink = `${subscriptionLink}&pw=1`;
    }
  }
  return (
    <div className={`${styles["lock-container"]} ${className}`}>
      <StoryViewStatus />
      <div className={styles["actions"]}>
        {access.grantReason === "METERING LOCAL" && (
          <StoryLockButton
            text={`மாதத்திற்கு <span class=${
              styles["additional-stories-count"]
            }>7</span> எக்ஸ்க்ளுசிவ் கட்டுரைகள் படிக்க லாகின் செய்யுங்கள்`}
            btnDescription={"Login"}
            href={loginLink}
          />
        )}
        {access.grantReason !== "SUBSCRIBE" && (
          <StoryLockButton
            text={"அனைத்து எக்ஸ்க்ளுசிவ் கட்டுரைகளையும் படிக்கசந்தா செய்யுங்கள்"}
            btnDescription={"Subscribe"}
            href={subscriptionLink}
          />
        )}
      </div>
    </div>
  );
};

StoryLock.propTypes = {
  className: PropTypes.string,
  access: PropTypes.shape({
    remainingStoriesCount: PropTypes.number
  }),
  loginLink: PropTypes.string,
  subscriptionLink: PropTypes.string,
  collectionId: PropTypes.string
};

function mapStateToProps(state) {
  const vikatanHosts = get(state, ["qt", "config", "vikatanHosts"], {});
  return {
    subscriptionLink: vikatanHosts.subscription,
    loginLink: `${vikatanHosts.login}/${global.location ? `?redirect_url=${global.location.href}` : ""}`
  };
}

export default connect(mapStateToProps)(StoryLock);
